export default [
    {
        size: {
            default: 3
        },
        type: "week-select",
        label: "Week Select"
    },
    {
        key: "toggle1",
        size: {
            default: 3
        },
        type: "toggle-button",
        label: "Test",
        inputSize: "small"
    },
    {
        key: "toggle2",
        size: {
            default: 3
        },
        type: "toggle-button",
        label: "Test"
    },
    {
        key: "k1",
        size: {
            default: 12
        },
        type: "text",
        label: "Test",
        inputSize: "small"
    },
    {
        size: {
            default: 3
        },
        type: "select",
        label: "Name",
        inputSize: "small",
        options: [
            {
                value: "gbrewster",
                label: "gbrewster"
            },
            {
                value: 'jallen',
                label: 'jallen'
            }
        ]
    },
    {
        size: {
            default: 3
        },
        type: "button",
        inputSize: "small",
        label: "Button SM"
    },
    {
        key: "k2",
        size: {
            default: 12
        },
        type: "text",
        label: "Test 2"
    },
    {
        size: {
            default: 3
        },
        type: "select",
        label: "Name",
        options: [
            {
                value: "gbrewster",
                label: "gbrewster"
            },
            {
                value: 'jallen',
                label: 'jallen'
            }
        ]
    },
    {
        size: {
            default: 3
        },
        type: "select",
        label: "Name",
        options: [
            {
                value: "gbrewster",
                label: "gbrewster"
            },
            {
                value: 'jallen',
                label: 'jallen'
            }
        ]
    },
    {
        size: {
            default: 3
        },
        type: "date",
        label: "Date"
    },
    {
        size: {
            default: 3
        },
        type: "time",
        label: "Time"
    },
    {
        size: {
            default: 3
        },
        type: "radio-group",
        // label: ['Month', 'Day']
        label: "",
        options: [
            {value: 'month', label: 'Month'},
            {value: 'day', label: 'Day'},
        ]
    }
]